import { useState } from "react";
import { useTranslation } from "react-i18next";
import { faqs } from "@/mocks/siteData";
import SectionHeading from "@/components/feature/SectionHeading";

export default function FaqSection() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="py-20 md:py-28 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <SectionHeading eyebrow={t("faq.eyebrow")} title={t("faq.title")} />

        <div className="space-y-3">
          {faqs.map((faq, index) => {
            const isOpen = openIndex === index;
            const question = t(`faq.${faq.id}.q`);
            return (
              <div
                key={faq.id}
                className={`rounded-lg border transition ${
                  isOpen ? "bg-background-100 border-primary-300" : "bg-background-100 border-background-200"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? null : index)}
                  aria-expanded={isOpen}
                  className="w-full flex items-center justify-between gap-5 text-left px-5 md:px-6 py-5 cursor-pointer"
                >
                  <h4 className="font-heading font-bold text-foreground-900 text-base md:text-lg">
                    <a href={`#faq-${faq.id}`} className="cursor-pointer">
                      {question}
                    </a>
                  </h4>
                  <span
                    className={`w-9 h-9 rounded-full flex items-center justify-center shrink-0 transition ${
                      isOpen ? "bg-primary-500 text-background-50 rotate-45" : "bg-background-200 text-foreground-700"
                    }`}
                  >
                    <i className="ri-add-line text-lg w-5 h-5 flex items-center justify-center" />
                  </span>
                </button>
                {isOpen && (
                  <div className="px-5 md:px-6 pb-6 -mt-1">
                    <p className="text-foreground-600 leading-relaxed text-[15px]">{t(`faq.${faq.id}.a`)}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}